import { useNavigate } from "react-router-dom"
import styles from "./BackButton.module.css"
import backButton from "./../../image/ic_back_button.png"
export const BackButton = ({onBackClick=()=>{}}:{onBackClick?:()=>void})=>{
    const navigation = useNavigate();
    return(
        <div className={styles.back_button_container}>
            <span onClick={()=>{
                onBackClick()
                navigation(-1)}} style={{cursor:"pointer"}}>
                <img src={backButton}/>
            </span>
        </div>
    )
}